import React from 'react';
import { cx } from '@twind/core';
import OstroChatAvatar from 'app/components/chatbot/OstroChatAvatar';
import { MessageReadMarker } from 'app/modules/live-chat/components/MessageReadMarker';

export default function BaseChatItem({
  children,
  className,
  showAvatar = true,
  avatarURL,
  messageIndex = 0,
  messageId = '',
}: {
  children: React.ReactNode;
  className?: string;
  showAvatar?: boolean;
  avatarURL?: string;
  messageIndex?: number;
  messageId?: string;
}) {
  return (
    <div
      data-message-index={messageIndex}
      data-testid="base-chat-item"
      aria-label="Ostro Chat Item"
      data-message-id={messageId}
      className={cx('ostro-chat-item relative scroll-mb-6', '~(mb-4 flex)', className)}
    >
      <div className={`mr-3 mb-3 basis-6 w-[24px] ${showAvatar ? 'h-[24px]' : 'h-[12px]'}`}>
        {showAvatar && <OstroChatAvatar src={avatarURL} />}
      </div>
      <div className="flex-1">{children}</div>
      {messageIndex ? <MessageReadMarker index={messageIndex} /> : null}
    </div>
  );
}
